import {observer} from 'mobx-react';
import React from 'react';
import {X7PushableBlockStore} from '../X7PushableBlockStore';
import {userStatusService} from '../../../../domain'

@observer
export class X7PushableBlockCardHeader extends React.Component<{ store: X7PushableBlockStore }> {
  render() {
    const {store} = this.props;
    const pushableBlock = store.loader.pushableBlock!;
    const mode = store.mode;
    const showAddControls = mode === 'view' || mode === 'add-block';
    const showReorderControls = mode === 'view';

    return (
      <div className="row align-items-center">
        <div className="col"> Blocks</div>
        {
          (showAddControls || showReorderControls) &&
          <div className="col-auto no-wrap">
            {
              (showAddControls && userStatusService.status.roles.ContentManager) &&
              <button type="button" className="btn btn-info"
                      onClick={() => store.beginAddBlock('Visible')}>
                Add Visible Block
              </button>
            }
            {
              (showAddControls && userStatusService.status.roles.ContentManager) &&
              <button type="button" className="btn btn-success"
                      onClick={() => store.beginAddBlock('Pushable')}>
                Add Pushable Block</button>
            }
            {
              (showAddControls && userStatusService.status.roles.ContentManager) &&
              <button type="button" className="btn btn-warning"
                      onClick={() => store.beginAddBlock('Hidden')}>
                Add Teacher Block</button>
            }
            {
              (showReorderControls && userStatusService.status.roles.ContentManager) &&
              <button type="button" className="btn btn-primary"
                      disabled={pushableBlock!.Blocks!.length < 2}
                      onClick={store.beginReorderBlocks}> Reorder
              </button>
            }
          </div>
        }
      </div>
    );
  }
}
